import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gear-icon',
  templateUrl: './gear-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GearIconComponent {}
